import { useState } from 'react'
import { useBahasa } from '../../../app/i18n'
import { useHapusLibur, useLibur, useTambahLibur } from '../../../domains/tenancy/api'
import {
  Baris, Bendera, Gagal, Isian, KepalaHalaman, Kosong, Memuat, Panel, PenyediaSimpan,
  Tab, Tabel, Tombol, TombolSimpanKepala,
} from '../../../shared/ui'
import JadwalBalas from './JadwalBalas'
import Ketersediaan from './Ketersediaan'
import SyaratMeeting from './SyaratMeeting'

/**
 * HARI LIBUR — milik TENANT, bukan blok ketersediaan seorang staf.
 *
 * Bedanya menanggung beban: libur nasional bukan "semua orang kebetulan memblokir hari
 * yang sama". Menyimpannya begitu menuntut satu baris per orang per tanggal, dan akan
 * salah begitu ada staf baru yang barisnya belum dibuat — harinya terbuka lagi untuk
 * seluruh tim (migrasi 0027).
 */
function Libur({ t }) {
  const q = useLibur()
  const tambah = useTambahLibur()
  const hapus = useHapusLibur()
  const [f, setF] = useState({ tanggal: '', keterangan: '' })

  return (
    <Panel judul={t('ta.liburJudul')} catatan={t('ta.liburCatatan')}>
      <div className="p-3.5 border-b border-line flex gap-2.5 items-end max-w-[64ch]">
        <label className="flex flex-col gap-1.5">
          <span className="text-[11px] font-semibold uppercase tracking-[.07em] text-ink3">
            {t('ta.kolTanggal')}
          </span>
          <Isian
            type="date"
            value={f.tanggal}
            onChange={(e) => setF({ ...f, tanggal: e.target.value })}
          />
        </label>
        <label className="flex flex-col gap-1.5 grow">
          <span className="text-[11px] font-semibold uppercase tracking-[.07em] text-ink3">
            {t('ta.kolKeterangan')}
          </span>
          <Isian
            value={f.keterangan}
            placeholder="Idul Fitri"
            onChange={(e) => setF({ ...f, keterangan: e.target.value })}
          />
        </label>
        <Tombol
          disabled={!f.tanggal || tambah.isPending}
          onClick={() => tambah.mutate(
            { tanggal: f.tanggal, keterangan: f.keterangan.trim() || null },
            { onSuccess: () => setF({ tanggal: '', keterangan: '' }) },
          )}
        >
          {tambah.isPending ? t('umum.menyimpan') : t('ta.tambahLibur')}
        </Tombol>
      </div>

      {(tambah.isError || hapus.isError) && (
        <Bendera nada="bad" role="alert" className="mx-3.5 mt-3">{(tambah.error || hapus.error)?.message}</Bendera>
      )}

      {q.isLoading && <Memuat tinggi={3} />}
      {q.isError && <Gagal galat={q.error} ulangi={q.refetch} />}
      {q.data && (q.data.length === 0 ? (
        <Kosong judul={t('ta.liburKosong')} keterangan={t('ta.liburKosongKet')} />
      ) : (
        <Tabel kepala={[t('ta.kolTanggal'), t('ta.kolKeterangan'), '']}>
          {q.data.map((h) => (
            <Baris key={h.id}>
              <td className="font-mono text-[11.5px]">{h.tanggal}</td>
              <td>{h.keterangan || '—'}</td>
              <td className="text-right">
                {/* HAPUS sungguhan, dan di sini itu benar: sebuah tanggal libur tidak
                    menyimpan isian siapa pun dan tidak pernah jadi rujukan baris lain.
                    Memaksanya jadi "nonaktifkan" cuma menumpuk baris mati. */}
                <Tombol
                  kecil
                  jenis="sekunder"
                  disabled={hapus.isPending}
                  onClick={() => hapus.mutate(h.id)}
                >
                  {t('ta.hapus')}
                </Tombol>
              </td>
            </Baris>
          ))}
        </Tabel>
      ))}
    </Panel>
  )
}

export default function AturMeeting() {
  const { t } = useBahasa()
  const [tab, setTab] = useState('syarat')
  return (
    <PenyediaSimpan>
      <KepalaHalaman
        judul={t('ta.navMeeting')}
        keterangan={t('ta.meetingKeterangan')}
        aksi={<TombolSimpanKepala t={t} />}
      />

      <Tab
        aktif={tab}
        set={setTab}
        daftar={[
          { id: 'syarat', label: t('ta.tabSyarat') },
          { id: 'tim', label: t('ta.tabKetersediaan') },
          { id: 'jadwal', label: t('ta.tabJadwalMeeting') },
          { id: 'libur', label: t('ta.tabLibur') },
        ]}
      />
      {tab === 'syarat' && <SyaratMeeting />}
      {tab === 'tim' && <Ketersediaan />}
      {tab === 'jadwal' && <JadwalBalas kunci="meeting" />}
      {tab === 'libur' && (
        <>
          <Libur t={t} />
          <Bendera nada="info" judul={t('ta.liburBedaJudul')} className="max-w-[80ch]">
            {t('ta.liburBedaIsi')}
          </Bendera>
        </>
      )}
    </PenyediaSimpan>
  )
}
